'use client';

import React, { useState, useEffect } from 'react';
import Image from 'next/image';
import HeroSection from './HeroSection';
import FeatureSection from './FeatureSection';
import ProcessSection from './ProcessSection';
import TestimonialSection from './TestimonialSection';
import CTASection from './CTASection';

const HomeInteractive = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
    
    // Check authentication status
    const checkAuth = () => {
      const token = localStorage.getItem('authToken');
      const user = localStorage.getItem('user');
      setIsAuthenticated(!!(token && user));
    };

    checkAuth();
  }, []);

  if (!isHydrated) {
    return (
      <div className="min-h-screen bg-background">
        <div className="animate-pulse">
          <div className="h-96 bg-muted"></div>
          <div className="space-y-8 p-8">
            <div className="h-8 bg-muted rounded w-3/4 mx-auto"></div>
            <div className="h-4 bg-muted rounded w-1/2 mx-auto"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <HeroSection isAuthenticated={isAuthenticated} />

      <section
        className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16"
        aria-label="About"
      >
        <div className="bg-card border border-border rounded-2xl p-8 md:p-12 shadow-sm flex items-start">
          <div className="w-1/4">
            <Image
              src="/imgs/sprout.png"
              alt="A sprouting plant, symbolizing the growth of a micro-garden"
              width={150} 
              height={150}
            />
          </div>
          <div className="w-3/4 pl-6">
            <h3 className="text-xl font-heading font-bold text-foreground mb-2">
              Why Microspace Optimizer Exists
            </h3>
            <p className="text-muted-foreground leading-relaxed max-w-3xl">
              <strong>This tool exists because 87% of urban dwellers want to grow food — but don’t know where to start.</strong>
              <br />
              We built this so you never need to Search <em>“how to grow basil in an apartment”</em> again.
            </p>

            <div id="about" className="mt-6">
              <h2 className="text-2xl font-heading font-bold text-foreground mb-4">About</h2>
              <p className="text-muted-foreground leading-relaxed">
                <strong>Microspace Optimizer</strong> is in its early growth phase — a smart <strong>micro-space planning app</strong>
                designed to help you unlock the hidden potential of any unused space, from compact balconies to tight urban yards.
                <br /><br />
                Our mission is to transform overlooked areas into <strong>productive, rewarding micro-environments</strong>
                using AI-driven personalization and simple, step-by-step actions anyone can follow.
              </p>

              <div className="mt-6">
                <a
                  href="mailto:teodor.mihai.dragos@gmail.com"
                  className="inline-flex items-center justify-center rounded-lg bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground transition hover:bg-primary/90"
                >
                  Contact
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <FeatureSection />
      <ProcessSection />
      <TestimonialSection />
      <CTASection isAuthenticated={isAuthenticated} />
    </div>
  );
};

export default HomeInteractive;
